
import { ReactComponent as ChevronIconRight } from "../../../assets/icons/chevron-right.svg";
import { ReactComponent as LinkExternalIcon } from "../../../assets/icons/link_external.svg";
import LoaderContent from "../loader-content/LoaderContent";

import "./CategoryEntries.scss";

export interface IItem {
    id: string,
    name: string,
    isFile: boolean,
    slug: string,
    path: string
    directAccess?: boolean
}

export interface ICategoriesEntries {
    items: IItem[],
    isLoading: boolean,
    isDisabled?: boolean,
    requestItemClick: (item: IItem) => void
}

export default function CategoriesEntries({ requestItemClick, isDisabled, isLoading, items }: ICategoriesEntries) {
    return (
        isLoading ?
            <LoaderContent /> :
            <ul className={`content-entries list ${isDisabled ? 'content-entries--disabled' : ''}`}>
                {
                    items.map((item) => (
                        <li className="acc-group__item" key={item.id}>
                            <button type="button"
                                disabled={isDisabled}
                                className={` acc-group__action 
                         ${item.isFile ? 'acc-group__action--file' : ''}
                         ${isDisabled ? 'acc-group__action--disabled' : ''} 
                         
                         d-flex`}
                                onClick={() => requestItemClick(item)}>

                                <span className="acc-group__action-title">
                                    {item.name}
                                </span>

                                <span className={`acc-group__action-icon`}>
                                    {
                                        item.isFile ? <LinkExternalIcon /> : <ChevronIconRight />
                                    }
                                </span>
                            </button>
                        </li>
                    ))
                }
            </ul>
    )
}
